import React, { useMemo } from 'react';

import { useAppContext, useFreecodeContext } from 'hooks/useContext';
import {
  ExerciseProgressContainer,
  HeaderIcon,
  LockIcon,
  ProgressHeader,
  LevelRow,
  LevelCircle,
  CheckMark,
  LevelLabel,
  ProgressLine,
} from './styles';

export default function ExerciseProgress() {
  const { isDarkMode } = useAppContext();
  const { test, testImpl, isCreator, exerciseOptions, setExerciseOptions } = useFreecodeContext();

  const levelSettings = useMemo(
    () =>
      [...Array(testImpl.configLevels.numPublic).keys()].map((levelIndex) => ({
        levelName: `Level ${levelIndex + 1} - ` + (testImpl.generated.allLevelNames?.[levelIndex] ?? 'unknown...'),
        unlocked: isCreator ? true : levelIndex < exerciseOptions.unlockedLevels,
        checked: levelIndex + 1 === exerciseOptions.levelToRun,
        showLine: levelIndex + 1 < testImpl.configLevels.numPublic,
      })),
    [testImpl.configLevels, testImpl.generated, exerciseOptions, isCreator]
  );

  const selectLevel = (index) => {
    let desiredLevel = index + 1;
    if (exerciseOptions.levelToRun === desiredLevel) return;
    if (desiredLevel > exerciseOptions.unlockedLevels) return;
    if (!isCreator) localStorage.setItem(`fsEditor-exercise-${test._id}-levelToRun`, desiredLevel);
    setExerciseOptions((oldOptions) => ({ ...oldOptions, levelToRun: desiredLevel }));
  };

  const renderLevelRow = (levelSettings, index) => (
    <LevelRow
      key={index}
      isDarkMode={isDarkMode}
      unlocked={levelSettings.unlocked}
      title={levelSettings.unlocked ? `Select level ${index + 1}` : 'Level Locked'}
      onClick={() => selectLevel(index)}
    >
      <LevelCircle checked={levelSettings.checked} isDarkMode={isDarkMode}>
        {!levelSettings.unlocked && <LockIcon />}
        {levelSettings.checked && <CheckMark isDarkMode={isDarkMode} />}
      </LevelCircle>
      <LevelLabel>{levelSettings.levelName}</LevelLabel>
      {levelSettings.showLine && <ProgressLine isDarkMode={isDarkMode} />}
    </LevelRow>
  );

  return (
    <ExerciseProgressContainer isDarkMode={isDarkMode}>
      <ProgressHeader isDarkMode={isDarkMode}>
        <HeaderIcon />
        {test.name}
      </ProgressHeader>
      {levelSettings.map(renderLevelRow)}
    </ExerciseProgressContainer>
  );
}
